<template>
  <div>
    <v-layout v-if="$vuetify.breakpoint.smAndDown" style="position: relative">
      <v-carousel
        height="250"
        hide-delimiters
        :cycle="false"
        class="parkingDetail"
      >
        <v-carousel-item :src="parkingImage"> </v-carousel-item>

        <v-carousel-item :src="imageLocationUrl"> </v-carousel-item>
      </v-carousel>

      <div v-if="countryHasBle" class="blerficSmallScreen font-weight-medium">
        <v-layout row>
          <v-flex class="text-xs-right">
            <parking-entry-buttons
              :parking="parking"
              :inverted="true"
            ></parking-entry-buttons>
          </v-flex>
        </v-layout>
      </div>

      <div
        v-if="$vuetify.breakpoint.smAndDown"
        class="addressSmallScreen font-weight-medium"
      >
        <h4 v-if="!isLogged" v-html="parking.name"></h4>
        <span v-html="parking.address"></span>
      </div>
    </v-layout>

    <v-layout v-else row wrap>
      <v-flex xs12 sm5>
        <v-img :aspect-ratio="16 / 9" height="250" :src="parkingImage"> </v-img>
      </v-flex>
      <v-flex xs12 sm7>
        <v-img :src="imageLocationUrl" height="250"> </v-img>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex
        xs12
        md5
        order-xs2
        order-md1
        :class="{ border: $vuetify.breakpoint.mdAndUp }"
        class="pa-3 white"
      >
        <parking-services
          v-if="$vuetify.breakpoint.mdAndUp"
          :parking="parking"
        ></parking-services>

        <v-divider v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
        <v-list class="n-lines">
          <v-list-tile v-if="$vuetify.breakpoint.mdAndUp" class="mt-2">
            <v-list-tile-content v-if="isLogged">
              <v-list-tile-title>
                {{ parking.address }}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-content v-else>
              <v-list-tile-title>
                {{ parking.name }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ parking.address }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Instrucciones de uso -->
          <v-divider
            v-if="mustShowParkingInstructions"
            class="mt-2"
          ></v-divider>
          <v-list-tile v-if="mustShowParkingInstructions" avatar class="mt-2">
            <v-list-tile-avatar>
              <v-icon large color="primary">help_outline</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">
                {{
                  $t('parking.instruccions.title')
                }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="parking.description.instructions"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- QR de acceso -->
          <v-layout v-if="qrCodeValue" row wrap justify-center class="mt-3">
            <v-flex xs12 class="text-xs-center">
              <qrcode-vue :value="qrCodeValue" :size="200" level="M"></qrcode-vue>
            </v-flex>
          </v-layout>

          <!-- Dónde aparcar -->
          <v-divider
            v-if="hasDescriptionType && isLogged"
            class="mt-2"
          ></v-divider>
          <v-list-tile
            v-if="hasDescriptionType && isLogged"
            avatar
            class="mt-2"
          >
            <v-list-tile-avatar>
              <v-icon large color="primary">place</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">
                {{ $t('parking.description.type.title') }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="parking.description.type.text"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Importante (observaciones tipo advertencia) -->
          <v-divider
            v-if="hadObservation && hadObservationAsWarning && isLogged"
            class="mt-2"
          ></v-divider>
          <v-list-tile
            v-if="hadObservation && hadObservationAsWarning && isLogged"
            avatar
            class="mt-2"
          >
            <v-list-tile-avatar>
              <v-icon large color="primary">error_outline</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                class="mb-1"
              >
                <span v-html="parking.description.observationWarning.title"></span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="parking.description.observationWarning.text"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Información (observaciones tipo información) -->
          <v-divider
            v-if="hadObservation && hadObservationAsInfo && isLogged"
            class="mt-2"
          ></v-divider>
          <v-list-tile
            v-if="hadObservation && hadObservationAsInfo && isLogged"
            avatar
            class="mt-2"
          >
            <v-list-tile-avatar>
              <v-icon large color="primary">info_outline</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                class="mb-1"
              >
                <span v-html="parking.description.observationInfo.title"></span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="parking.description.observationInfo.text"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Acceso en coche -->
          <v-divider
            v-if="hasAccessDriving && isLogged"
            class="mt-2"
          ></v-divider>
          <v-list-tile v-if="hasAccessDriving && isLogged" avatar class="mt-2">
            <v-list-tile-avatar>
              <v-icon large color="primary">directions_car</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                class="mb-1"
              >
                <span v-html="parking.description.accessDriving.title"></span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="parking.description.accessDriving.text"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Acceso a pie -->
          <v-divider
            v-if="hasAccessWalking && isLogged"
            class="mt-2"
          ></v-divider>
          <v-list-tile v-if="hasAccessWalking && isLogged" avatar class="mt-2">
            <v-list-tile-avatar>
              <v-icon large color="primary">directions_walk</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                class="mb-1"
              >
                <span v-html="parking.description.accessWalking.title"></span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="parking.description.accessWalking.text"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Descripción (solo visible si es detalle de parking) -->
          <v-divider v-if="hasParkingDescription" class="mt-2"></v-divider>
          <v-list-tile v-if="hasParkingDescription" avatar class="mt-2">
            <v-list-tile-avatar>
              <v-icon large color="primary">menu_book</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                class="mb-1"
              >
                <span v-html="parking.description.description.title"></span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="parking.description.description.text"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Plazas eléctricas -->
          <v-divider
            v-if="parking.hasElectricSpots && isLogged"
            class="mt-2"
          ></v-divider>
          <v-list-tile
            v-if="parking.hasElectricSpots && isLogged"
            avatar
            class="mt-2"
          >
            <v-list-tile-avatar>
              <v-icon large color="primary">bolt</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">
                {{ $t('global.electricSpots') }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ $t('parkingAccessType.electric.point1.line1') }}
              </v-list-tile-sub-title>
              <v-list-tile-action>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  class="capitalize white--text"
                  @click="showElectricModal"
                >
                  {{ $t('global.more.info') }}
                </v-btn>
              </v-list-tile-action>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs12 md7 order-xs1 order-md2>
        <parking-services
          v-if="$vuetify.breakpoint.smAndDown"
          :parking="parking"
        ></parking-services>

        <slot></slot>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import utilService from '@/services/utilService';
import ParkingServices from '@/components/commons/ParkingServices';
import ParkingEntryButtons from '@/components/commons/ParkingEntryButtons';
import QrcodeVue from 'qrcode.vue';
import _ from 'lodash';
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'ParkingCommon',
  components: {
    [ParkingServices.name]: ParkingServices,
    [ParkingEntryButtons.name]: ParkingEntryButtons,
    QrcodeVue,
  },
  props: {
    parking: {
      type: Object,
      required: true,
    },
    isParkingDetail: {
      type: Boolean,
      default: false,
      required: false,
    },
    accessCode: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      // loaded: false
      countryHasBle: store.state.countrySelected.hasBle,
    };
  },
  computed: {
    isLogged: function () {
      return store.state.isLogged;
    },
    imageLocationUrl: function () {
      if (!_.isEmpty(this.parking)) {
        let imageSize = utilService.getMapImageSize(
          this.$vuetify.breakpoint.name
        );
        return `${this.parking.image}?type=map&lat=${this.parking.lat}&lng=${this.parking.lon}&${imageSize}&z=18`;
      }
      return 'https://dummyimage.com/800x800/fff/aaa';
    },
    parkingImage() {
      if (_.isEmpty(this.parking)) {
        return 'https://dummyimage.com/800x800/fff/aaa';
      }
      let imageSize = utilService.getParkingImageSize(
        this.$vuetify.breakpoint.name,
        false
      );
      return `${this.parking.image}?${imageSize}`;
    },
    hasParkingDescription() {
      if (!this.isParkingDetail) return false;
      if (
        _.isEmpty(this.parking) ||
        _.isEmpty(this.parking.description) ||
        _.isEmpty(this.parking.description.description) ||
        _.isEmpty(this.parking.description.description.text)
      ) {
        return false;
      }
      return true;
    },
    mustShowParkingInstructions() {
      if (this.isParkingDetail) {
        return false;
      }
      if (
        _.isEmpty(this.parking) ||
        _.isEmpty(this.parking.description) ||
        _.isEmpty(this.parking.description.instructions)
      ) {
        return false;
      }
      return true;
    },
    hadObservation() {
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (typeof this.parking.description === 'undefined') {
        return false;
      }
      return this.hadObservationAsInfo || this.hadObservationAsWarning;
    },
    hadObservationAsInfo() {
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (typeof this.parking.description.observationInfo === 'undefined') {
        return false;
      }
      return this.parking.description.observationInfo !== null;
    },
    hadObservationAsWarning() {
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (typeof this.parking.description.observationWarning === 'undefined') {
        return false;
      }
      return this.parking.description.observationWarning !== null;
    },
    hasDescriptionType() {
      if (this.isParkingDetail) {
        return false;
      }
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (typeof this.parking.description.type === 'undefined') {
        return false;
      }
      return !_.isEmpty(this.parking.description.type.text);
    },
    hasAccessWalking() {
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (typeof this.parking.description.accessWalking === 'undefined') {
        return false;
      }
      return !_.isEmpty(this.parking.description.accessWalking.text);
    },
    hasAccessDriving() {
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (typeof this.parking.description.accessDriving === 'undefined') {
        return false;
      }
      return !_.isEmpty(this.parking.description.accessDriving.text);
    },
    qrCodeValue() {
      if (this.accessCode && this.accessCode.startsWith('[QR]')) {
        return this.accessCode.substring(4);
      }
      return null;
    },
    hasElectricInformation() {
      if (_.isEmpty(this.parking)) {
        return false;
      }
      if (typeof this.parking.description.electric === 'undefined') {
        return false;
      }
      return !_.isEmpty(this.parking.description.electric);
    },
  },
  methods: {
    showElectricModal() {
      EventBus.$emit(keys.eventShowElectricModal, {});
    },
  },
};
</script>

<style lang="scss" scoped>
.addressSmallScreen {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #88c1dfd1;
  color: white;
  font-size: 1.2em;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 10px;
}

.blerficSmallScreen {
  position: absolute;
  top: 0;
  width: 100%;
  background: #88c1df00;
  color: #88c1dfff;
  font-size: 1.2em;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 16px;
}
</style>
